import helperStyles from "@src/components/helpers.module.scss";
import { buildPortalAssetUrl } from "@src/utils/portalAssets.utils";
import React from "react";

export const ViaGogo = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<div className={helperStyles.textPrimary}>
				<img src={buildPortalAssetUrl("/images/viagogo_icon.png")} alt="viagogoIcon" />
			</div>
		</div>
	);
};
